<template>
  <header>
    <!-- <NavBar v-if="shouldShowDefaultNav"/> -->
    <ProjectNavbar v-if="shouldShowProjectNav"/>
  </header>
</template>

<script>
import NavBar from "@/components/principal-page/NavBar.vue";
import ProjectNavbar from "@/components/principal-page/ProjectNavbar.vue";

export default {
  name: 'MainLayout',
  components: {
    NavBar,
    ProjectNavbar
  },
  computed: {
    shouldShowProjectNav() {
      return this.$route.path.includes('/template') || 
             this.$route.path.includes('/board');
    },
    shouldShowDefaultNav() {
      return !this.shouldShowProjectNav;
    }
  }
};
</script>